<!-- <div class="pdf-container">
  <pdf-viewer [src]="srcValue" [original-size]="false"></pdf-viewer>
</div>
<div >
<a class="disppdf" [href] = "srcValue" target="_blank"> {{srcLink['cl_title']}}
<div class="text-primary">
  <i class="fa fa-download" aria-hidden="true" ></i>
</div>
</a>
</div> -->

<div class="page">
  <div class="header">Angular sample</div>
  <div #viewer class="viewer"></div>
</div>